import React, { FC, useCallback } from 'react';
import { FilterRadioHidden } from 'Components/FilterRadioHidden';
import Dropdown from 'Components/Dropdown';
import withErrorBoundary from 'HOC/ErrorBoundary';

interface Props {
  callback?: (event: any, identifier: any) => void;
  activityWithInstitution?: any;
}

const options = [
  // Get this from Redux
  { label: 'Within Last 7 Days', value: 'Within_Last_7_Days' },
  { label: 'Within Last 30 Days', value: 'Within_Last_30_Days' },
  { label: 'Within Last 90 Days', value: 'Within_Last_90_Days' },
  { label: 'Within Last 365 Days', value: 'Within_Last_365_Days' },
];
const overrideStyles = { color: '#079DC0' };
const colorOverRide = {
  open: {
    border: {
      color: '#B4E1EC',
    },
    text: {
      color: '#079DC0',
    },
  },
  close: {
    border: {
      color: '#B4E1EC',
    },
    text: {
      color: '#079DC0',
    },
  },
};

const ActivityWithMyInstitution: FC<Props> = (props: Props) => {
  const { callback, activityWithInstitution } = props;

  const handleDropDownChange = (e: any, id: string) => {
    // Find the selected value
    const value = e.target.value.toLocaleLowerCase();
    const selectedOption = options.find(
      (option) => option.value.toLocaleLowerCase() === value
    );

    callback({ target: { value: selectedOption, id } }, id);
  };
  const activityWithInstitutionCallBack = (e: any) => {
    // Pass the identifier back to the callback
    callback(e, 'activityWithInstitution');
  };

  return (
    <>
      <FilterRadioHidden
        label="Any"
        value="Any"
        overrideStyles={overrideStyles}
        selected={activityWithInstitution.selection === 'Any'}
        identifier="activityWithInstitution"
        onClick={useCallback(activityWithInstitutionCallBack, [
          activityWithInstitution,
        ])}
      />
      <FilterRadioHidden
        label="Active"
        value="Active"
        overrideStyles={overrideStyles}
        selected={activityWithInstitution.selection === 'Active'}
        identifier="activityWithInstitution"
        onClick={useCallback(activityWithInstitutionCallBack, [
          activityWithInstitution,
        ])}
      >
        <Dropdown
          ariaLabel="Select Activity Range with my Insitution"
          colorOverRide={colorOverRide}
          items={options}
          defaultValue={
            activityWithInstitution.selection === 'Active'
              ? activityWithInstitution.value
              : null
          }
          onChange={useCallback(
            (e: any) => {
              // Pass the identifier
              handleDropDownChange(e, 'Active');
            },
            [activityWithInstitution]
          )}
        />
      </FilterRadioHidden>
      <FilterRadioHidden
        label="Inactive"
        value="Inactive"
        overrideStyles={overrideStyles}
        selected={activityWithInstitution.selection === 'Inactive'}
        identifier="activityWithInstitution"
        onClick={useCallback(activityWithInstitutionCallBack, [
          activityWithInstitution,
        ])}
      >
        <Dropdown
          ariaLabel="Select Inactivity Range with my Insitution"
          colorOverRide={colorOverRide}
          items={options}
          defaultValue={
            activityWithInstitution.selection === 'Inactive'
              ? activityWithInstitution.value
              : null
          }
          onChange={useCallback(
            (e: any) => {
              // Pass the identifier
              handleDropDownChange(e, 'Inactive');
            },
            [activityWithInstitution]
          )}
        />
      </FilterRadioHidden>
    </>
  );
};

ActivityWithMyInstitution.defaultProps = {
  callback: () => {},
  activityWithInstitution: undefined,
};

export default withErrorBoundary(ActivityWithMyInstitution);
